import { render, staticRenderFns } from "./ResubmissionForm.vue?vue&type=template&id=9971f61c&"
import script from "./ResubmissionForm.vue?vue&type=script&lang=js&"
export * from "./ResubmissionForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ResubmissionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports